import { PlanFragment, isPlanFragment } from './PlanFragment'

import { Category, isCategory } from './Category'

import { FeatureFragment, isFeatureFragment } from './FeatureFragment'

import plansInfoFragmentRawString from '../PlansInfoFragment.graphql'

export const plansInfoFragmentString = plansInfoFragmentRawString

export type PlansInfoFragment = {
  plans: PlanFragment[]
  categories: Category[]
  features: FeatureFragment[]
}

export const isPlansInfoFragment = (
  fragment: any,
): fragment is PlansInfoFragment =>
  fragment &&
  Array.isArray(fragment.plans) &&
  fragment.plans
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isPlanFragment(next) as boolean),
      true,
    ) &&
  Array.isArray(fragment.categories) &&
  fragment.categories
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isCategory(next) as boolean),
      true,
    ) &&
  Array.isArray(fragment.features) &&
  fragment.features
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) => accum && (isFeatureFragment(next) as boolean),
      true,
    )
